import { Link } from '@/components/elements/Link'
import { Divider } from '@/components/elements/Divider'
import {
  PinIcon,
  MailIcon,
  ChatBubbleIcon,
} from '@/components/elements/ContactIcons'

export type AddressObject = {
  headquarters: string
  street: string
  city: string
}

export interface ContactSidebarProps {
  title: string
  subtitle: string
  address?: AddressObject
  phone?: string
  email?: string
}

export const ContactSidebar: React.FC<ContactSidebarProps> = ({
  title,
  subtitle,
  address,
  phone,
  email,
}) => {
  const addressInBlock = Object.values(address)
    .flat()
    .map((line) => <p key={line}>{line}</p>)

  return (
    <div className="flex flex-col items-center justify-center h-full bg-beige">
      <section className="relative flex flex-col justify-center mx-auto px-8 py-16 max-w-lg md:px-20">
        <h3 className="mb-2 mt-4 font-display text-5xl font-black leading-tight">
          {title}
        </h3>
        <p className="mb-4 font-body text-lg font-semibold">{subtitle}</p>
        <Divider className="mb-2 mt-2" small />
        <div className="inline-flex items-start mr-3 font-body">
          <PinIcon className="mr-2 w-5 h-5" />
          <address className="font-body not-italic font-semibold">
            {addressInBlock}
          </address>
        </div>
        <Divider className="mb-2 mt-2" small />
        <div className="inline-flex items-center mr-3 font-body">
          <ChatBubbleIcon className="mr-2 w-5 h-5" />
          <Link
            className="py-4 font-semibold sm:py-0"
            variant="secondary"
            target="_blank"
            href={`tel:${email}`}
          >
            <span>{phone}</span>
          </Link>
        </div>
        <Divider className="mb-2 mt-2" small />
        <div className="inline-flex items-center font-body">
          <MailIcon className="mr-2 w-5 h-5" />
          <Link
            className="py-4 font-semibold sm:py-0"
            variant="secondary"
            target="_blank"
            href={`mailto:${email}`}
          >
            {email}
          </Link>
        </div>
      </section>
    </div>
  )
}
